import { render } from "./FrequentlyAskedQuestions.vue?vue&type=template&id=4f519c76&ts=true"
import script from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=ts"
export * from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__